import { useSelector } from 'react-redux';

import {
    getCommonOrgId,
    getDealXgId,
    getDealXgVersion,
    isFullPageScrollEnabled,
    useDealerDetailsSelector
} from '@makemydeal/dr-sales-checkin-store';
import { hasLoadingIndicatorDisappearsClockRestarted } from '@makemydeal/dr-shared-ui-utils';
import { routingConfig } from '@makemydeal/dr-sales-checkin-types';
import { useAppRouter } from '@makemydeal/dr-sales-checkin-ui-utils';

/**
 * Cohort/context attributes for `useLoadingIndicatorDisappearsTelemetry` (US2078790) — this app's
 * own deal/dealer/route context, kept out of the shared (app-agnostic) hook.
 */
export const useShowroomLoadingIndicatorAttributes = (): Record<string, unknown> => {
    const dealId = useSelector(getDealXgId);
    const dealVersion = useSelector(getDealXgVersion);
    const commonOrgId = useSelector(getCommonOrgId);
    const { dealerMMDId } = useDealerDetailsSelector();
    const { pathname } = useAppRouter();
    const isFullScrollView = useSelector(isFullPageScrollEnabled);

    return {
        dealId,
        dealVersion,
        commonOrgId,
        dealerMMDId,
        isShowroomMode: pathname.startsWith(routingConfig.BASE_ROUTE),
        isFullScrollView,
        startedFromRoleAssumption: hasLoadingIndicatorDisappearsClockRestarted()
    };
};
